/**
 * Created by amirb on 7/12/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var Window = require('web-agent-assets-js/lpWindow');

    lpTag.lpWindowController = function (model) {
        this.applicationType = "lpWindowController";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var windowApi;

        this.getWindow = function (data) {
            getWindow(data);
        };

        initializeApi();

        function initializeApi() {
            windowApi = new Window();
        }

        /////////////////////////////// Window DATA ///////////////////////////////////

        function getWindow(data) {
            logger.info("", "getWindow", data);
            var id;
            if (data) {
                id = data.id;
            }
            if (id) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleWindowSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleWindowError, data),
                    context: data
                };
                windowApi.getWindow(requestObj, id);
            }
        }

        function handleWindowSuccess(data) {
            logger.info("engagements return as Success", "handleWindowSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpWindowController.prototype.handleACRequestSuccess(model, data, lpTag.lpWindowController.prototype.serviceNames.window, getSingleWindowObject, context, dataObject);
        }

        function handleWindowError(data) {
            logger.error("", "handleWindowError", data);
            logger.graph({name: 'handleWindowError'});
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpWindowController.prototype.handleRequestError(model, data, lpTag.lpWindowController.prototype.serviceNames.window, data && data.visitorId, dataObject);
        }

        function getSingleWindowObject(windowObject, name) {
            if (!windowObject.json && this.responseCode !== 304) {
                return;
            }
            var toReturn = lpTag.lpWindowController.prototype.getDataFromModelIfNotModified(model, this, name) || {
                    id: windowObject.id,
                    surveyAgentChatEnabled: windowObject.json.surveyAgentChatEnabled,
                    surveyAgentChatId: windowObject.json.surveyAgentChatId
                };
            var visitorId = windowObject.visitorId || (windowObject.dataObject && windowObject.dataObject.data && windowObject.dataObject.data.visitorId);
            lpTag.lpWindowController.prototype.addToVisitorInfoById(model, 'window', toReturn, visitorId, windowObject && windowObject.dataObject, lpTag.lpWindowController.prototype.serviceNames.window);
            return toReturn;
        }
    };
    lpTag.lpWindowController.prototype = new lpBaseInfoController();

    return lpTag.lpWindowController;

});
